import apiClient from "./client";

export async function fetchNotifications(signal) {
  const response = await apiClient.get("notifications/", { signal });
  return response.data;
}

export async function markNotificationRead(notificationId) {
  const response = await apiClient.post(`notifications/${notificationId}/read/`);
  return response.data;
}

export async function markAllNotificationsRead() {
  const response = await apiClient.post("notifications/read-all/");
  return response.data;
}
